import React, { useState } from 'react';
import PropTypes from 'prop-types';

import FilterNavigation from '../../../../molecules/filter-navigation/FilterNavigation.jsx';
import CategoryTeaser from '../../../../molecules/category-teaser/CategoryTeaser.jsx';

const TeaserContainerCategories = ({ data }) => {
  const { categoryTeasers, filterNavigation, headline, headlineOption } = data;
  const [activeFilter, setActiveFilter] = useState([]);

  const Tag = headlineOption || 'h2';

  return (
    <div className=" l-container l-container--has-margin l-container--column">
      <div className="l-container__wrapper">
        <div className="l-container__grid">
          {headline && (
            <Tag className="a-headline o-teaser-container-categories__headline">{headline}</Tag>
          )}

          {filterNavigation && (
            <FilterNavigation
              {...filterNavigation}
              headlineClassName="a-headline--sub"
              className="o-teaser-container-categories__filter"
              setActiveFilter={setActiveFilter}
              activeFilter={activeFilter}
              hasFilterToggle
            />
          )}

          <div className="o-teaser-container-categories__teasers">
            {categoryTeasers.map(
              (teaser, index) =>
                (activeFilter.some(filter => teaser.tags.indexOf(filter.slug) !== -1) ||
                  activeFilter.length === 0) && (
                  <CategoryTeaser
                    key={teaser.id || index}
                    headline={teaser.headline}
                    text={teaser.text}
                    href={teaser.href}
                  />
                )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

TeaserContainerCategories.propTypes = {
  data: PropTypes.shape().isRequired
};

export default TeaserContainerCategories;
